import { render, staticRenderFns } from "./LettersSoundsSyllables.vue?vue&type=template&id=0e7ec7a8&lang=pug&"
import script from "./LettersSoundsSyllables.vue?vue&type=script&lang=js&"
export * from "./LettersSoundsSyllables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports